import { useEffect, useState } from "react";
import { AiOutlineDownload } from "react-icons/ai";
import { useParams } from "react-router-dom";
import Table from "../table/index";
import Pagination from "../pagination/index";
import { downloadEventListCsvService, downloadEventListPdfService, getEventListService, getEventOriginalImageService } from "../../services/api-service";
import { MDBCard, MDBCardBody } from "mdb-react-ui-kit";
import { triggerBase64Download } from 'react-base64-downloader';

import React,{useMemo } from "react";
import { Container, Row, Col,Nav, Navbar,Button } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OverallStudentAttendance from "components/OverallStudentAttendance/OverallStudentAttendance";
import CustomerJourneyChart from "components/CustomerJourneyChart/CustomerJourneyChart";
import FunnelChart from "components/FunnelChart/FunnelChart";
import Alerts from "components/Alerts/Alerts";
import { getEmotionHomePageSummaryService } from "services/api-service";
import "./Dashboard.css";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import SearchIcon from '@mui/icons-material/Search';
import ModeCommentIcon from '@mui/icons-material/ModeComment';

import { useLocation } from "react-router-dom";


import routes from "routes.js";


function Eventoccur() {
  const theme = useTheme();
  const md_matches = useMediaQuery(theme.breakpoints.down('md'));
  const sm_matches = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);

  const [eventData, seteventData] = useState([]);
  const { event } = useParams();

  const handleStartDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const [pageData, setPageData] = useState({
    rowData: [],
    isLoading: false,
    totalPages: 0,
    totalRecords: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSizeState, setPageSizeState] = useState(5);
  const columns = [
    {
      Header: "Id",
      accessor: "id",
    },
    {
      Header: "Image",
      accessor: "thumbnail",
      Cell: (tableProps) => (
        <td
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          {Base64ToImage(tableProps.row.original.thumbnail)}
        </td>
      ),
    },
    {
      Header: "Event",
      accessor: "event",
    },
    {
      Header: "Camera Name",
      accessor: "camera_name",
    },
    {
      Header: "Date",
      accessor: "date",
    },
    {
      Header: "Time",
      accessor: "time",
    },
    {
      Header: "Vehicle Number",
      accessor: "vehicle_number",
    },
    {
      Header: "Vehicle Category",
      accessor: "vehicle_category",
      // Cell: (tableProps) => (
      //  <td
      //    style={{
      //      display: "flex",
      //      justifyContent: "center",
      //    }}
      //  >
      //    {tableProps.row.original.alert_created ? "True" : "False"}
      //  </td>
      // ),
    },
    {
      Header: "Download",
      Cell: (tableProps) => {
        let file_name = (`${tableProps.row.original.camera_name}_${tableProps.row.original.id}_${tableProps.row.original.event}_${tableProps.row.original.date}_${tableProps.row.original.time}`).replace(/ /g,"_");
        return (
          <button
  onClick={() => { DownloadOriginalImage(tableProps.row.original.id, file_name) }}
  style={{ backgroundColor: 'black', color: 'white' }}
>
  Download
</button>
        )
      },
    }
  ];

  const DownloadOriginalImage = (evenr_id, file_name) => {
    getEventOriginalImageService(evenr_id).then((response) => {
      triggerBase64Download(`data:image/png;base64,${response.data}`, file_name);
    });
  }

  const Base64ToImage = (base64String) => {
    if (
      base64String === null ||
      base64String === undefined ||
      base64String === ""
    )
      return <img src={""} height="70" alt="base64" />;

    const imageUrl = `data:image/png;base64,${base64String}`;
    return <img src={imageUrl} height="70" alt="base64" />;
  };

  const getEventName = () => {
    switch (event) {
      case "Lost":
        return "Lost";
      case "antibullying":
        return "Anti Bullying";
      case "Emotion Analysis":
        return "Emotion";
      case "numberplate":
        return "Number Plate";
      case "Unauthorized":
        return "Unauthorized access";
      case "cattle":
        return "Cattle";
      case "fire":
        return "Fire";
      case "intruder":
        return "Intruder";
      default:
        return "all";
    }
  };

  const getEventLabelName = () => {
    switch (event) {
      case "Lost":
        return "Lost";
      case "antibullying":
        return "Anti Bullying";
      case "Emotion Analysis":
        return "Emotion";
      case "numberplate":
        return "Number Plate";
      case "Unauthorized":
        return "Unauthorized access";
      case "cattle":
        return "Cattle";
      case "fire":
        return "Fire";
      case "intruder":
        return "Intruder";
      default:
        return "all";
    }
  };

  let getCsv = async () => {
    const body = { event: event, date:selectedDate};
    downloadEventListCsvService(body).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response?.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", event + ".csv");
      document.body.appendChild(link);
      link.click();
    }).catch(() => {
    })
  };
  
  let getPdf = async () => {
    const body = { event: event, date: selectedDate };
    downloadEventListPdfService(body).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response?.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", event + ".pdf");
      document.body.appendChild(link);
      link.click();
    }).catch(() => {
    })
  };

  let getData = async (pageNo, pageSize,date) => {
    const body = {
      event: getEventName(),
      date: date,
      page_number: pageNo,
      page_size: pageSize,
    };
    try {
      const response = await getEventListService(body);
      seteventData(response?.data);
      return response?.data;
    } catch (error) {
      return {};
    }
  };

  useEffect(() => {
    setPageData((prevState) => ({
      ...prevState,
      rowData: [],
      isLoading: true,
    }));
    getData(currentPage, pageSizeState,selectedDate).then((info) => {
      const { data, total_records, page_number, page_size } = info;
      setPageData({
        isLoading: false,
        rowData: data,
        totalPages: (total_records / page_size) | 0,
        totalRecords: total_records,
      });
    });
  }, [currentPage, pageSizeState,selectedDate]);

  return (
    <>
   {md_matches?<div className="dashboard-headers"style={{marginTop:'0.1%',borderTop:'none'}}>
        
           <div className="dashboard-header-contents">
           <div style={{marginRight:'118px'}}> Universal Sector
             {/* <img src={logo1}></img> */}
             </div>
             <div className="dashboard-controlss">
               <span style={{color: "rgba(0, 0, 0, 0.5)"}}>Date:</span>
               <input
                 type="date"
                 className="date-input"
                 value={selectedDate}
                 onChange={handleStartDateChange}
                 aria-label="Select date"
                 style={{width:'150px',marginLeft:'-2%'}}
               />
              
              <div style={{color:'blue',borderRadius:'20px'}}>
                 <SearchIcon style={{fontSize:'40px'}}></SearchIcon>
               </div>
   
               
             
             
             </div>
           </div>
         </div>: <Navbar className="dashboard-headers"  style={{ background: "white",height:'20px',marginTop:'0.1%',borderTop:'none'}}> 
         <Container fluid>
         <Navbar.Collapse id="basic-navbar-nav">
                   <Nav className="nav mr-auto" navbar >
                     <div
                       style={{
                         fontSize: "20px",
                         fontWeight: "bold",
                         borderColor: "black",
                         
                        
                       }}
                     >
                       Universal Sector Dashboard
                   {/* Temple <img src={logo1}></img> */}
                     </div>
                   </Nav>
                 </Navbar.Collapse>
                 
             <div className="dashboard-controls">
               <span style={{color: "rgba(0, 0, 0, 0.5)", }}>Date:</span>
               <input
                 type="date"
                 className="date-input"
                 value={selectedDate}
                 onChange={handleStartDateChange}
                 aria-label="Select date"
               />
              <div style={{color:'blue',borderRadius:'20px'}} >
                 <SearchIcon style={{fontSize:'40px'}}></SearchIcon>
               </div>
             </div>
             </Container>
          </Navbar>}
    <div className="camcont">
      <div className="camset row d-flex justify-content-center">
        <div className="camsetting row d-flex justify-content-center">
          <div className="setting-card w-100" style={{ marginLeft: "20px" }}>
            <div className="cam-selc-card" style={{ height: "10px" }}>
              <MDBCard className="cam-selc-card">
                <MDBCardBody>
                  <div style= {{ 
                          display: 'flex',
                          justifyContent: "space-between",
                          flexDirection: "row",
                          alignItems:"center",
                          margin:"0px"
                        }}>
                    <div style={{color:"white", fontSize:20}}>{getEventLabelName()}</div>

                    <button className="btn btn-success btn-md" onClick={getPdf} 
                        style={{ marginRight: "0px" , backgroundColor:"#dd0a0a"}}>
                        <AiOutlineDownload style={{ marginRight: "10px" }} />
                        Download PDF
                    </button>
                    
                    <button className="btn btn-success btn-md" onClick={getCsv} 
                        style={{ marginRight: "0px" }}>
                        <AiOutlineDownload style={{ marginRight: "10px" }} />
                        Download CSV
                    </button>
                    
                    <div>
                      <select value={pageSizeState} onChange={(event)=>setPageSizeState(+event.target.value)}>
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="d-flex justify-content-center">
                      <Table
                        columns={columns}
                        data={pageData.rowData}
                        isLoading={pageData.isLoading}
                      />
                    </div>
                  </div>
                  <div className="row" style={{backgroundColor:"black", color:"white"}}>
                    <div className="d-flex justify-content-center">
                      {pageData.isLoading ? (
                        ""
                      ) : (
                        <Pagination
                          totalRows={pageData.totalRecords}
                          pageChangeHandler={setCurrentPage}
                          rowsPerPage={pageSizeState}
                          currentPage={currentPage}
                        />
                      )}
                    </div>
                  </div>
                </MDBCardBody>
              </MDBCard>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default Eventoccur;
